<template>
  <div style="display: contents">
    <slot name="lg" v-if="mode.isLg" />
    <slot name="lgmd" v-if="mode.isLgMd" />
    <slot name="md" v-if="mode.isMd" />
    <slot name="mdsm" v-if="mode.isMdSm" />
    <slot name="sm" v-if="mode.isSm" />
  </div>
</template>

<script>
export default {
  computed: {
    mode () {
      const isSm = window.matchMedia('(max-width: 600px)').matches
      const isMd = window.matchMedia('(min-width: 601px) and (max-width: 1200px)').matches
      const isMdSm = window.matchMedia('(max-width: 1200px)').matches
      const isLg = window.matchMedia('(min-width: 1201px)').matches
      const isLgMd = window.matchMedia('(min-width: 601px)').matches

      return {
        isSm,
        isMdSm,
        isMd,
        isLgMd,
        isLg
      }
    }
  }
}
</script>
